import type {
  RequestPasswordResetCommand,
  RequestPasswordResetResult,
  ResetPasswordCommand,
  ResetPasswordResult,
} from "@/domain/model/PasswordReset";
import type {
  PasswordResetInitRequestDto,
  PasswordResetInitResponseDto,
  PasswordResetRequestDto,
  PasswordResetResponseDto,
} from "../dto/PasswordResetDto";

export function mapRequestPasswordResetCommandToDto(
  cmd: RequestPasswordResetCommand,
): PasswordResetInitRequestDto {
  return {
    email: cmd.email.trim(),
  };
}

export function mapPasswordResetInitResponseDtoToModel(
  dto: PasswordResetInitResponseDto,
): RequestPasswordResetResult {
  return {
    accepted: dto.accepted === true,
  };
}

export function mapResetPasswordCommandToDto(
  cmd: ResetPasswordCommand,
): PasswordResetRequestDto {
  return {
    token: cmd.token.trim(),
    password: cmd.password,
  };
}

export function mapPasswordResetResponseDtoToModel(
  dto: PasswordResetResponseDto,
): ResetPasswordResult {
  return {
    passwordChanged: dto.passwordChanged === true,
  };
}
